module.exports = __webpack_public_path__ + "static/media/apresentacao.9f4e7fde.mp4";